<div class="is-flex is-column gap-16 is-fullheight">

  <div class="is-flex is-justify-space-between gap-16">
    <app-icon [routerLink]="['..']" skipLocationChange="true" class="text-24 is-cursor-pointer" name="back"></app-icon>
    <app-text class="text-20 is-family-semiBold">{{ 'common-app.__WEBAPP_HC_COMPARE_FUS_TITLE3' | AsyncLang | async }}</app-text>
    <app-icon [routerLink]="['../../']" skipLocationChange="true" (click)="close()" class="text-24 is-cursor-pointer" name="close"></app-icon>
  </div>

  <div>
    <app-text class="text-align-center">{{ 'common-app.__WEBAPP_HC_COMPARE_FUS_DESCRIPTION3' | AsyncLang | async }}</app-text>
  </div>
  <app-first-use-slide-animation [animationUrl]="'/assets/images/control-page/first-use-slides/FUS_Temporal.json'"></app-first-use-slide-animation>


  <div class="is-flex is-column gap-16">
    <lay-button class="is-flex-button" [routerLink]="['../../']" skipLocationChange="true" (click)="close()">
      <button class="is-primary-button">
        <app-text [text]="'common-app.__DISCOVER' | AsyncLang | async"></app-text>
      </button>
    </lay-button>
  </div>

</div>
